var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-none",attrs:{"text":"","color":"primary","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.btnData.icon)+" ")]),_vm._v(" "+_vm._s(_vm.$t(_vm.btnData.descr))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }